import { render, staticRenderFns } from "./deviceDetection.vue?vue&type=template&id=1ab31e6e&scoped=true"
import script from "./deviceDetection.vue?vue&type=script&lang=ts"
export * from "./deviceDetection.vue?vue&type=script&lang=ts"
import style0 from "./deviceDetection.vue?vue&type=style&index=0&id=1ab31e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab31e6e",
  null
  
)

export default component.exports